import { HttpClient } from '@angular/common/http';
import { ErrorcontrolService } from 'basecomponents';
import { Observable, Subject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AppInjector } from 'base-models';

/**
 * class to check version on server.
 * This version checks using a file. This must be extended to use an API Rest endpoint
 */
export class VersionCheck {

    public appVersionTimer;
    public appVersionTimerInterval = 10000;// 1000 * 60 * 30;//in milliseconds, defaults to 30 minutes
    public notify$ = new Subject<any>();
    //url:string="/assets/appversion.json"
    public stopOnCheck: boolean = false;

    /**
     * list of callbacks to call. It´s strongly recomended to use notify$
     * You must use: callBacks.push(function.bind(this)); if the function use the keyword this inside the funcion
     */
    public callBacks: any[] = [];
    private taskStarted=false;
    private checkingVersion=false;


    private http: HttpClient;
    private errorcontrolservice: ErrorcontrolService;
    /**
     * 
     */
    constructor(
        public urlApiFile: string
        , public timerInterval = null
        ) {

        if (timerInterval!=null) {
            this.appVersionTimerInterval = timerInterval;
        }

        const injector = AppInjector.getInjector();
        if (injector) {
          this.http = injector.get(HttpClient);
          this.errorcontrolservice = injector.get(ErrorcontrolService);
        }
        else{
          console.error("ERROR ON VersionCheck class. INJECTOR IS NULL");
        }


    }
    /**
     * Start the checking after configuration
     */
    public checkAppVersionTask() {
        if (this.taskStarted){
            return;
        }
        this.taskStarted=true;
        if (this.appVersionTimer) {
            clearInterval(this.appVersionTimer);
        }

        this.appVersionTimer = setInterval(() => {
            if (this.checkingVersion){
                return;
            }
            this.checkingVersion=true;

            this.checkAppVersionFromServer()
                .subscribe(
                    res => {
                        
                        this.checkingVersion=false;
                        if (this.stopOnCheck) {
                            this.stopCheck();
                        }
                        this.notify$.next(res);
                        this.executeCallBacks(res);   

                    },
                    err => {
                        this.checkingVersion=false;
                        console.log("Error retrieving version number", err);
                    }
                )
        }, this.appVersionTimerInterval);
    }

    /**
     * simple method to check version
     */
    private checkAppVersionFromServer(): Observable<any> {

         // timestamp request to invalidate cache
        let query = this.http.get<any[]>(this.urlApiFile + '?t=' + new Date().getTime())
            .pipe(
                catchError(this.errorcontrolservice.handleError<any>('checkAppVersionFromServer'))
            );
        return query;
    }

    public executeCallBacks(serverResponse: any) {
        if (!this.callBacks) {
            return;
        }
        for (let call of this.callBacks) {
            try {
                call(serverResponse);
            }
            catch (e) {
                console.error(e);
            }

        }
    }

    stopCheck() {
        if (this.appVersionTimer) {
            clearInterval(this.appVersionTimer);
        }
    }
} 